import React from 'react';
import styled from 'styled-components';
import CloseBtn from '@panel/commons/assets/icons/close.svg';
import { select } from '@panel/commons/core/themev2';

const Step = ({ title, bodyText, onClose }) => {
  return (
    <StepContainer>
      <UpperArea>
        <Title data-panel='panel-tour-title'>{title}</Title>
        <Close data-panel='panel-tour-close' onClick={onClose} />
      </UpperArea>
      <BodyText data-panel='panel-tour-text'>{bodyText}</BodyText>
    </StepContainer>
  );
};

const StepContainer = styled.div`
  white-space: normal;
`;

const UpperArea = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 4px;
  max-width: 100%;
`;

const Close = styled.div`
  background-image: ${`url(${CloseBtn})`};
  width: 18px;
  height: 26px;
  background-size: contain;
  background-repeat: no-repeat;
  cursor: pointer;
`;

const BodyText = styled.div`
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  color: ${select('darkGray')};
  max-width: 100%;
  white-space: break-spaces;
`;

export default Step;
